import CardWithVideo from './CardWithVideo'


export default CardWithVideo
